<div class="container eighth-container">
  <div class="row eighth-container-top">
    <div class="col-6 image-left">
      <div class="eighth-container-title mt-2"
           [ngClass]="{'eighth-container-title-ru mt-2': currentLang === Language.RU}">
        {{ 'home-page-content.traditional_meets' | translate }}
      </div>
      <div class="eighth-container-subtitle mt-2"
           [ngClass]="{'eighth-container-subtitle-ru mt-2': currentLang === Language.RU}">
        {{ 'home-page-content.traditional_meets_text' | translate }}
      </div>
      <button class="filled-button tall-button mt-4"
              (click)="orderNow()">{{ 'home-page-content.traditional_meets_button' | translate }}
      </button>
    </div>
    <div class="col-6 d-flex align-items-center">
      <img src="assets/homepage/premium-physical-cards/background.png" alt="eighth section img"
           class="i-width-100 premium-cards-bg">
    </div>
  </div>
</div>

<section class="section-wrapper-mb eighth-container-mb">
  <div class="d-flex justify-content-center align-items-center i-width-100">
    <img src="assets/homepage/premium-physical-cards/background.png" alt="eighth section img"
         class="width-80">
  </div>
  <div class="flex-direction-column i-width-100">
    <div class="eighth-container-title mt-2"
         [ngClass]="{'eighth-container-title-mb mt-2': currentLang === Language.HY}">
      {{ 'home-page-content.traditional_meets' | translate }}
    </div>
    <div class="eighth-container-subtitle mt-2">
      {{ 'home-page-content.traditional_meets_text' | translate }}
    </div>
    <button
      class="filled-button tall-button mobile-button mt-4"
      (click)="orderNow()">{{ 'home-page-content.traditional_meets_button' | translate }}
    </button>
  </div>

</section>
